import { Button, Space, Typography, Divider } from "antd";
import { useTranslation } from "react-i18next";

import { useSidePanel } from "@/modules/side-panel";
import { Alert } from "@/ui/alert";

const DissociateComponent = ({
  questionText = "",
  buttonText = "",
  isLoading = false,
  isError = false,
  onDissociateClick = () => {},
  onAlertCloseClick = () => {},
}) => {
  const { t } = useTranslation();
  const { closeSidePanel } = useSidePanel();

  return (
    <>
      <Alert display={isError} closable={{ afterClose: onAlertCloseClick }} />
      <Typography.Text>{questionText}</Typography.Text>
      <Divider />
      <Space>
        <Button onClick={closeSidePanel}>{t("global:cancel")}</Button>
        <Button onClick={onDissociateClick} loading={isLoading} type="primary">
          {buttonText || t("global:dissociate")}
        </Button>
      </Space>
    </>
  );
};

export default DissociateComponent;
